module.exports = __webpack_public_path__ + "static/media/icon-filter.0588b780.svg";